import * as types from "../types/index";
import { core } from "./core";

export const uploadFile = (data) => {
  return core.API(
    "POST",
    `/attachment/document`,
    types.UPLOAD_FILE,
    types.UPLOAD_FILE_SUCCESS,
    types.UPLOAD_FILE_FAILURE,
    data
  );
};

export const deleteFile = (queryString) => {
  return core.API(
    "DELETE",
    `/attachment/document${queryString ? `?${queryString}` : ""}`,
    types.DELETE_FILE,
    types.DELETE_FILE_SUCCESS,
    types.DELETE_FILE_FAILURE
  );
};

export const uploadImage = (data) => {
  return core.API(
    "POST",
    `/attachment/image`,
    types.UPLOAD_IMAGE,
    types.UPLOAD_IMAGE_SUCCESS,
    types.UPLOAD_IMAGE_FAILURE,
    data
  );
};

export const deleteImage = (queryString) => {
  return core.API(
    "DELETE",
    `/attachment/image${queryString ? `?${queryString}` : ""}`,
    types.DELETE_IMAGE,
    types.DELETE_IMAGE_SUCCESS,
    types.DELETE_IMAGE_FAILURE
  );
};
